module.exports = __webpack_public_path__ + "img/calendar-18_fill.0c6f7d73.svg";